<template>
    <div class="checkin-box">
        <div class="title-bar">
            <led-timer v-if="timerRequired" :time-in-seconds="timeInSeconds" type="countup" />
            <div :class="{'no-timer': !timerRequired}" class="title">
                <span :class="{'blinking': openFlag === 'Y'}" class="dot"></span>{{ title }}
            </div>
            <div class="stat-info">
                <span v-show="!allCheckin" class="label">已签到</span>
                <span v-show="!allCheckin" class="data">{{ checkinCount }}</span>
                <span v-show="!allCheckin" class="label">未签到</span>
                <span v-show="!allCheckin" class="data">{{ memberCount - checkinCount }}</span>
                <span v-show="allCheckin" class="label">全勤</span>
            </div>
        </div>
        <div ref="checkinBox" class="checkin-data-box">
            <div v-if="showPoints" class="points">
                <canvas ref="canvas"></canvas>
            </div>
            <!-- if the checkin is ended, the users will be placed in seperated sections-->
            <div v-if="openFlag !== 'Y'" class="end">
                <div v-if="absenceMembers.length > 0" class="section">未签到</div>
                <div v-if="absenceMembers.length > 0" class="users">
                    <div v-for="u in absenceMembers" :key="u.id" class="user checked">
                        <div class="avatar-box" :class="u.absenceType.toLowerCase()">
                            <img :src="u.avatarUrl" alt="">
                        </div>
                        <div class="name">
                            {{ u.fullName }}
                        </div>
                    </div>
                </div>
                <div v-if="checkinMembers.length > 0" class="section">已签到</div>
                <div v-if="checkinMembers.length > 0" class="users">
                    <div v-for="cu in checkinMembers" :key="cu.id" class="user checked">
                        <div class="avatar-box">
                            <img :src="cu.avatarUrl" alt="">
                        </div>
                        <div class="name">
                            {{ cu.fullName }}
                        </div>
                        <div v-if="teacherHasPosition" class="dis">
                            <img class="dis-icon" :src="disIcon">
                            <span class="dis-label">{{ calculateDistance(cu) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- if the checkin is in progress, the users will be places in one box -->
            <div v-if="openFlag === 'Y'" class="in-progress">
                <div class="users">
                    <div v-for="user in members" 
                         :id="user.id"
                         :key="user.id" 
                         :class="{'checked': user.checkinFlag === 'Y'}" 
                         class="user">
                        <div class="avatar-box">
                            <img :src="user.avatarUrl" alt="">
                        </div>
                        <div class="name">
                            {{ user.fullName }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import ledTimer from './ledTimer.vue';
import Vue from 'vue';
import disIcon from '../assets/image/dis-icon.png';
import defaultAvatar from '../assets/image/default-avatar.png';

export default {
    components: {
        ledTimer
    },

    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        currentShow: {
            type: String,
            default: ''
        }
    },

    data: function() {
        return {
            componentId: null,
            serverTimestamp: 0,
            disIcon: disIcon,
            defaultAvatar: defaultAvatar,
            id: 0,
            clazzCourseId: null,
            checkinType: null,
            points: null,
            openFlag: 'N',
            openTime: null,
            reportPosFlag: 'N',
            lat: 0,
            lng: 0,
            memberCount: 0,
            checkinCount: 0,
            members: [],
            checkinMembers: [],
            absenceMembers: [],
            // if received showPoints message, change this property. but the point DOM show/hide is controlled by computed property: showPoints
            loDashShowPoints: true, 
            supportedEventNames: [
                'checkin.start',
                'checkin.showPoints',
                'checkin.hidePoints',
                'checkin.end',
                'checkin.updateMembers',
                'checkin.checked',
                'common.moveJoystick'
            ]
        };
    },

    computed: {
        title: function() {
            return this.openFlag === 'Y' 
                ? (this.checkinType === 'POINT_9' 
                    ? '手势签到中' 
                    : '签到进行中') 
                : '签到已结束';
        },

        allCheckin: function() {
            console.log('all checkin: ', (this.checkinCount >= this.memberCount));
            return (this.checkinCount >= this.memberCount);
        },

        timerRequired: function() {
            if (this.currentShow !== this.componentId) return false;
            return this.openFlag === 'Y';
        },

        timeInSeconds: function() {
            if (this.currentShow !== this.componentId) return 0;
            const stime = (new Date(this.openTime)).getTime();
            const now = Date.now();
            return Math.round((now - stime) / 1000);
        },

        showPoints: function() {
            return this.checkinType === 'POINT_9' && this.loDashShowPoints;
        },

        /**
         * If the teacher has reported his position
         * @return {boolean} 
         */
        teacherHasPosition: function() {
            const lat = parseInt(this.lat);
            const lng = parseInt(this.lng);

            return this.reportPosFlag === 'Y' 
                    && -180 <= lng && lng <= 180
                    && -90 <= lat && lat <= 90;
        }
    },

    watch: {
        currentShow: function(newVal, oldVal) {
            if (newVal !== this.componentId && oldVal === this.componentId) {
                this.resetScene();
            }
        }, 

        showPoints: function(newVal) {
            if (newVal) {
                Vue.nextTick(() => {
                    this.drawPoints(this.getPoints(this.points));
                });
            }
        }
    },

    created: function() {
    },

    mounted: function() {
        this.componentId = this.$attrs.id;
        window.addEventListener('message', this.windowMessageHandler);
    },

    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);
    },

    

    methods: {
        windowMessageHandler: function(e) {
            const msg = e.data;
            if ( ! msg) return;
            if (this.currentShow !== this.componentId) return;
            if ( ! msg.eventName || this.supportedEventNames.indexOf(msg.eventName) === -1) return;

            const msgData = msg.data;
            // console.log(msgData);
            switch (msg.eventName) {
                case 'checkin.start':
                    this.showCheckin(msgData);
                    break;
                case 'checkin.showPoints':
                    if (msgData.id != this.id) return;
                    this.showGesturePoints();
                    break;
                case 'checkin.hidePoints':
                    if (msgData.id != this.id) return;
                    this.hideGesturePoints();
                    break;
                case 'checkin.updateMembers':
                    if (msgData.id != this.id) return;
                    this.handleMemberUpdateMessage(msgData);
                    break;
                case 'checkin.checked':
                    if (msgData.id != this.id) return;
                    this.handleMemberCheckedMessage(msgData);
                    break;
                case 'checkin.end':
                    console.log(this.id);
                    if (msgData.id != this.id) return;
                    this.handleCheckinEndMessage();
                    break;
                case 'common.moveJoystick':
                    this.moveJoystick(msgData);
                    break;
                default:
                    // statements_def
                    break;
            }
        },
        
        /**
         * Show the checkin on the screen
         * @see  {@link https://p.mbook.cc/w/screenx/000-msg/01projector/04checkin/#4-1}
         * @param  {Object} msgData the message data
         * @return {void}         
         */
        showCheckin: function(msgData) {
            if (! msgData) return;
            const data = JSON.parse(JSON.stringify(msgData));
            this.serverTimestamp = data.serverTimestamp;
            const checkin = data.checkin;
            this.id = checkin.id;
            this.clazzCourseId = checkin.clazzCourseId;
            this.checkinType = checkin.checkinType;
            this.points = checkin.points;
            this.openFlag = checkin.openFlag;
            this.openTime = checkin.openTime;
            this.reportPosFlag = checkin.reportPosFlag;
            this.lat = checkin.lat;
            this.lng = checkin.lng;
            this.memberCount = checkin.members.length;
            
            checkin.members.forEach(m => {
                if (! m.avatarUrl) m.avatarUrl = this.defaultAvatar;
                if (! ('absenceType' in m)) m.absenceType = 'AB';
                if ( ! m.checkinFlag) m.checkinFlag = 'N';
                if ( ! ('studentNo' in m) || m.studentNo == null) m.studentNo = '';
            });

            checkin.members.sort((a, b) => {
                if (a.checkinFlag === 'Y' && b.checkinFlag === 'Y') {
                    return (b.checkinTime.localeCompare(a.checkinTime));
                } else if (a.checkinFlag != b.checkinFlag) {
                    return a.checkinFlag === 'Y' ? 0 : 1;
                } else {
                    return a.studentNo.localeCompare(b.studentNo);
                }
            });

            this.members.splice(0);
            this.absenceMembers.splice(0);
            this.checkinMembers.splice(0);

            checkin.members.forEach(m => {
                if (m.checkinFlag === 'Y') {
                    this.checkinCount++;
                } 
                this.members.push(m);
            });

            if (this.checkinType === 'POINT_9') this.loDashShowPoints = true;
        },

        /**
         * Show the points
         * @see  {@link https://p.mbook.cc/w/screenx/000-msg/01projector/04checkin/#4-2}
         * @return {void} 
         */
        showGesturePoints: function() {
            this.loDashShowPoints = true;
        },

        /**
         * hide the points
         * @see {@link https://p.mbook.cc/w/screenx/000-msg/01projector/04checkin/#4-3}
         * @return {void}
         */
        hideGesturePoints: function() {
            this.loDashShowPoints = false;
        },

        /**
         * [handleMemberCheckedMessage description]
         * @see {@link https://p.mbook.cc/w/screenx/000-msg/01projector/04checkin/#4-6}
         * @param  {Object} msgData 
         * @return {void}         
         */
        handleMemberCheckedMessage: function(msgData) {
            if ( ! msgData || ! msgData.userId) return;
            if (this.openFlag !== 'Y') return;

            // console.log(msgData)
            const userId = msgData.userId;
            const index = this.members.findIndex(m => m.id === userId);
            if (index === -1) {
                console.log('error, user ', userId, ' checked in but can not be found in the checkin ', this.id, ' members collection');
                return;
            }
            const member = this.members[index];
            if (member.checkinFlag === 'Y') {
                console.log('user ', userId, ' has checked in, do not duplicate check');
                return;
            }
            this.members.splice(index, 1);

            member.checkinFlag = 'Y';
            member.reportPosFlag = msgData.reportPosFlag;
            member.lat = msgData.lat;
            member.lng = msgData.lng;
            this.checkinCount++;
            member.checkinTime = (new Date()).toISOString();
            this.members.unshift(member);
        },



        /**
         * Member checkin status is modified by teacher
         * @see {@link https://p.mbook.cc/w/screenx/000-msg/01projector/04checkin/#4-4}
         * @param  {Object} msgData the message data
         * @return {void}         
         */
        handleMemberUpdateMessage(msgData) {
            if (this.openFlag === 'Y') return;
            console.log(msgData);
            let newCheckinMembers = [];
            msgData.memberIds.forEach(uid => {
                const absenceIndex = this.absenceMembers.findIndex(mm => mm.id === uid);
                const checkinIndex = this.checkinMembers.findIndex(mm => mm.id === uid);
                console.log('memberupdate message, check user id', uid, ', checkin index:', checkinIndex, ', absence index:', absenceIndex);
                let m = null;
                if (msgData.checkinFlag === 'N') {
                    if (checkinIndex !== -1 && absenceIndex === -1) { // checkin --> absence
                        m = this.checkinMembers[checkinIndex];
                        console.log(m);
                        this.checkinMembers.splice(checkinIndex, 1);
                        m.checkinFlag = 'N';
                        m.absenceType = msgData.absenceType;
                        this.absenceMembers.unshift(m);
                        this.checkinCount--;
                        console.log(m.fullName, 'is moved from checkin to absence');
                    } else if (checkinIndex === -1 && absenceIndex !== -1) { // absence --> absence
                        m = this.absenceMembers[absenceIndex];
                        m.absenceType = msgData.absenceType;
                        Vue.set(this.absenceMembers, absenceIndex, m);
                        console.log(m.fullName, 'is updated absence type');
                    } else {
                        console.log('checkin index:', checkinIndex, ', absence index:', absenceIndex, ', something seems wrong, please check');
                    }
                } else if (msgData.checkinFlag === 'Y') {
                    if (checkinIndex === -1 && absenceIndex !== -1) { // absence --> checkin
                        m = this.absenceMembers[absenceIndex];
                        this.absenceMembers.splice(absenceIndex, 1);
                        m.checkinFlag = 'Y';
                        m.absenceType = 'CK';
                        // this.checkinMembers.unshift(m);
                        newCheckinMembers.push(m);
                        this.checkinCount++;
                        console.log(m.fullName, 'is moved from absence to checkin');
                        // console.log(m);
                    } else if (checkinIndex !== -1 && absenceIndex === -1) { // checkin --> checkin
                        m = this.checkinMembers[checkinIndex];
                        console.log('user', m.fullName, 'is checked in, nothing to do');
                    } else {
                        console.log('checkin index:', checkinIndex, ', absence index:', absenceIndex, ', something seems wrong, please check');   
                    }
                } else {
                    console.log('unknow checkin flag:', msgData.checkinFlag);
                }
            });
            this.sortAbsenceMembers();
            this.checkinMembers = newCheckinMembers.concat(this.checkinMembers);
        },

        sortAbsenceMembers: function() {
            const type2Val = {
                AB: 0,
                IL: 1,
                PL: 2,
                LT: 3,
                EL: 4
            };
            this.absenceMembers.sort((a, b) => {
                if (a === b) return 0;

                if (a == null && b != null) {
                    return -1;
                }

                if (a != null && b == null) {
                    return 1;
                }

                if (! (a.absenceType in type2Val) || ! (b.absenceType in type2Val)) {
                    console.log('I do not find the absence type on ', a, 'or', b);
                    return 0;
                }

                let d = type2Val[a.absenceType] - type2Val[b.absenceType];
                if (d != 0) return d;

                return a.studentNo.localeCompare(b.studentNo);
            });

            // this.checkinMembers.sort((a,b) => {
            //     if (a === b) return 0;

            //     if (a == null && b != null) {
            //         return -1;
            //     }

            //     if (a != null && b == null) {
            //         return 1;
            //     }

            //     return a.studentNo.localeCompare(b.studentNo);
            // })
        },

        /**
         * Handle checkin end message
         * 
         * @see {@link https://p.mbook.cc/w/screenx/000-msg/01projector/04checkin/#4-5}
         * @return {void} 
         */
        handleCheckinEndMessage: function() {
            this.openFlag = 'N';
            // Get the checked and unchecked member to separated collections
            this.checkinMembers = this.members.filter(m => m.checkinFlag === 'Y');
            this.absenceMembers = this.members.filter(m => m.checkinFlag === 'N');

            this.members.splice(0);
            this.sortAbsenceMembers();
            this.loDashShowPoints = false;
        },

        /**
         * Calculate the distance between student and teacher
         * @param  {Object} member the student object
         * @return {string}        the distance with unit
         */
        calculateDistance: function(member) {
            
            if ( ! this.teacherHasPosition) return '未知';
            if (member.reportPosFlag !== 'Y') return '未开启';

            const tLat = parseFloat(this.lat);
            const tLng = parseFloat(this.lng);
            const mLat = parseFloat(member.lat);
            const mLng = parseFloat(member.lng);
            if (!(-90 <= mLat && mLat <= 90 && -180 <= mLng && mLng <= 180)) {
                return '未开启';
            }

            const d2r = Math.PI / 180;
            const radLat1 = tLat * d2r;
            const radLat2 = mLat * d2r;

            const a = radLat1 - radLat2;
            const b = (tLng - mLng) * d2r;

            let d = 2 * Math.asin(Math.sqrt(Math.sin(a/2) ** 2 + Math.cos(radLat1) * Math.cos(radLat2) * Math.sin(b / 2) ** 2));
            // d *= 6378137;
            d = Math.floor(d * 6378137);

            // console.log(d);

            if (d == 0) {
                return '距你 1 m';
            } else if (d > 0 && d < 1000) {
                return d + 'm';
            } else if (d >= 1000 && d < 50000) {
                return (d / 1000) + 'km';
            } else if (d >= 50000) {
                return '大于 50 km';
            } else {
                return '未开启';
            }
        },

        /**
         * Conert the points string to point array
         * @param  {string} pointsString the points string, like: 0-2-3
         * @return {array}              the points array
         */
        getPoints: function(pointsString) {
            if ( ! pointsString) return [];
            const points = pointsString.split('-').map(s => parseInt(s));
            return points;
        },

        /**
         * Reset the scene
         * @return {void}
         */
        resetScene: function() {
            this.serverTimestamp = 0;
            this.id = 0;
            this.clazzCourseId = null;
            this.openFalg = 'N';
            this.openTime = null;
            this.members.splice(0);
            this.absenceMembers.splice(0);
            this.checkinMembers.splice(0);
            this.memberCount = 0;
            this.checkinCount = 0;
            this.loDashShowPoints = false;
        },

        /**
         * @param {array} points connected points indexes array. in the 9-point canvas, the indexes of the points are:
         * 0 1 2 
         * 3 4 5
         * 6 7 8
         */
        drawPoints: function(points) {
            if ( ! this.$refs.canvas) return;
            if (! points) points = [];
            const canvas = this.$refs.canvas;
            const rect = canvas.getBoundingClientRect();
            const dpr = window.devicePixelRatio ? window.devicePixelRatio : 1.0;
            canvas.setAttribute('width', rect.width * dpr);
            canvas.setAttribute('height', rect.height * dpr);
            canvas.setAttribute('css-width', rect.width);
            canvas.setAttribute('css-height', rect.height);
            const context = canvas.getContext('2d');
            context.save();
            context.scale(dpr, dpr);

            const width = +(canvas.getAttribute('css-width'));
            const height = +(canvas.getAttribute('css-height'));

            const space = 45;
            const borderWidth = 2;

            let innerRadius = 0;
            let outerRadius = 0;

            outerRadius = parseInt(((width - space * 2) / 6) - (borderWidth));
            innerRadius = parseInt(outerRadius * 0.28);
            let d = outerRadius * 2;
            
            const pi2 = Math.PI * 2;
            
            const centers = [];
            for (let i = 0; i < 9; i++) {
                let col = i % 3;
                let row = Math.floor(i / 3);
                let x = (d + space) * col + outerRadius + (col * 2 + 1) * borderWidth;
                let y = (d + space) * row + outerRadius + (row * 2 + 1) * borderWidth;;
                centers.push({x: x, y: y});
            }

            context.clearRect(0, 0, width, height);
            context.fillStyle = 'red';
            context.strokeStyle = 'white';
            context.lineWidth = borderWidth;

            for (let i = 0; i < 9; i++) {
                let x = centers[i].x;
                let y = centers[i].y;
                context.beginPath();
                context.arc(x, y, outerRadius, 0, pi2);
                if (points.indexOf(i) === -1) {
                    context.strokeStyle = '#cccccc';
                    context.stroke();
                } else {
                    context.strokeStyle = '#5A9BDC';
                    context.fillStyle = 'rgba(90, 155, 220, 0.3)';
                    context.fill();
                    context.stroke();
                }
            }

            if (points.length > 1) {
                let x = centers[points[0]].x;
                let y = centers[points[0]].y;
                let lastX = x;
                let lastY = y;

                context.lineWidth = 4;
                

                for (let i = 1, n = points.length; i < n; i++) {
                    context.strokeStyle = '#BBC2C6';
                    context.beginPath();
                    context.moveTo(lastX, lastY);
                    x = centers[points[i]].x;
                    y = centers[points[i]].y;
                    
                    let theta = 0;
                    let x1 = 0;
                    let y1 = 0;
                    // 尝试将 x 轴旋转到和箭头同方向，也就是说箭头位于新坐标系的 x 轴负方向
                    if (x === lastX) {
                        theta = y > lastY ? 0.5 * Math.PI : 1.5 * Math.PI;
                    } else if (y === lastY) {
                        theta = x > lastX ? 0 : Math.PI;
                    } else {
                        theta = Math.atan((y - lastY) / (x - lastX));
                        x1 = x + innerRadius * Math.cos(theta);
                        y1 = y + innerRadius * Math.sin(theta);

                        let d0 = Math.sqrt((x - lastX) ** 2 + (y - lastY) ** 2);
                        let d1 = Math.sqrt((x1 - lastX) ** 2 + (y1 - lastY) ** 2);
                        // 如果直线和园的交点在更远的那个半圆，那么就正是我们要的旋转角度，否则就再旋转 PI
                        if (d1 < d0) {
                            theta = theta + Math.PI;
                        }
                    }

                    // 计算线段终点和内圆（实际上比内圆更大一点儿的圆）的交叉点，
                    // 线段并不直接画到目标点的正中心，是因为这个线比较粗，如果画到内圆正中心
                    // 会导致中点的三角形盖不住底下的线，出现不够尖尖的三角形
                    x1 = x + (innerRadius + 6) * Math.cos(theta + Math.PI);
                    y1 = y + (innerRadius + 6) * Math.sin(theta + Math.PI);
                    context.lineTo(x1, y1);
                    context.stroke();
                    
                    context.save();
                    context.translate(x, y);
                    context.rotate(theta);
                    let a = 4;
                    context.fillStyle = '#BBC2C6';
                    context.beginPath();
                    context.moveTo(-innerRadius, 0);
                    context.lineTo(-4 * a - innerRadius, +2 * a);
                    context.lineTo(-4 * a - innerRadius, -2 * a);
                    context.closePath();
                    context.fill();
                    context.restore();

                    lastX = x;
                    lastY = y;
                }

                context.fillStyle = '#ffffff';
                for (let i = 0, n = points.length; i < n; i++) {
                    let x = centers[points[i]].x;
                    let y = centers[points[i]].y;
                    context.beginPath();
                    context.arc(x, y, innerRadius, 0, pi2);
                    context.fill();
                }
            }
        },

        moveJoystick: function(msgData) {
            let direction = msgData.direction;
            let checkinBox = this.$refs.checkinBox;

            if (direction === 'LEFT') {
                return;
            } else if (direction === 'RIGHT') {
                return;
            } else if (direction === 'UP') {
                checkinBox.scrollTop -= 40;
            } else if (direction === 'DOWN') {
                checkinBox.scrollTop += 40;
            } else {
                return;
            }
            
        },
    }
};
</script>


<style scoped>
    .clearfix:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: " ";
        clear: both;
        height: 0;
    }

    .title-bar {
        display: flex;
        align-items: flex-start;
        height: 40px;
        padding: 20px 40px 20px 40px;
        background-color: #191919;
    }

    .title-bar .led-timer {
        flex-grow: 0;
        width: 320px;
    }

    .title-bar .stat-info {
        flex-grow: 0;
        width: 350px; 
        text-align: right;
        line-height: 36px;
        vertical-align: middle;
    }

    .title-bar .stat-info .label {
        flex-grow: 1;
        font-size: 18px;
        color: #BBC2C6;
        vertical-align: middle;
        padding: 0 10px;
    }

    .title-bar .stat-info .data {
        display: inline-block;
        font-size: 30px;
        color: #ffffff;
        vertical-align: middle;
    }

    .title-bar .title {
        height: 40px;
        line-height: 40px;
        vertical-align: middle;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        text-align: center;
        font-size: 24px;
        flex-grow: 1;
        color: #ffffff;
    }

    .title-bar .title.no-timer {
        padding-left: 320px;
    }

    .dot {
        display: inline-block;
        width: 18px;
        height: 18px;
        margin-right: 15px;
        border-radius: 10px;
        background-color: #cccccc;
    }

    .dot.blinking {
        background-color: #FF4C4C;
        animation-iteration-count: infinite;
        animation-duration: 1s;
        animation-name: blinking
    }

    @keyframes blinking {
        0% {
            opacity: 1.0;
        }

        50% {
            opacity: 0.0;
        }

        100% {
            opacity: 1.0;
        }
    }

    .checkin-data-box {
        position: absolute;
        top: 80px;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-x: hidden;
        overflow-y: auto;
        background-color: #2a2a2a;
        display: flex;
        padding: 40px;
    }

    .checkin-data-box .points {
        width: 300px;
        height: 300px;
        flex-grow: 0;
        flex-shrink: 0;
        padding-right: 40px;
    }

    .checkin-data-box .points canvas {
        width: 100%;
        height: 100%;
    }

    .checkin-data-box .users {
        display: flex;
        justify-content: flex-start;
        align-content: space-around;
        flex-wrap: wrap;
    }

    .checkin-data-box .users .user {
        flex-grow: 0;
        flex-shrink: 0;
        width: 170px;
        /* height: 120px; */
        padding-bottom: 40px;
        text-align: center;
        opacity: 0.3;
    }

    .checkin-data-box .end {
        
    }

    .checkin-data-box .end,
    .checkin-data-box .in-progress {
        flex-grow: 1;
    }

    .checkin-data-box .end .section {
        font-size: 30px;
        color: #E8E8E8;
        text-align: left;
        padding-top: 40px;
        padding-bottom: 40px;
        padding-left: 45px;
    }

    .checkin-data-box .end .section:first-child {
        padding-top: 0;
    }

    .checkin-data-box .users .user.checked {
        opacity: 1.0;
    }

    .checkin-data-box .users .user {
        position: relative;
    }

    .checkin-data-box .users .user .avatar-box {
        border: 4px solid #ffffff;
        width: 72px;
        height: 72px;
        border-radius: 40px;
        overflow: hidden;
        background-color: #cccccc;
        display: inline-block;
    }

    .checkin-data-box .users .user .avatar-box::after {
        display: block;
        position: absolute;
        left: 45px;
        top: 50px;
        width: 80px;
        height: 30px;
        line-height: 30px;
        vertical-align: middle;
        width: 80px;
        text-align: center;
        color: #ffffff;
        border-radius: 4px;
    }

    .checkin-data-box .users .user .avatar-box.ab::after {
        content: '缺勤';
        background-color: #C83737;
    }

    .checkin-data-box .users .user .avatar-box.il::after {
        content: '病假';
        background-color: #3C896D;
    }

    .checkin-data-box .users .user .avatar-box.lt::after {
        content: '迟到';
        background-color: #D9992C;
    }

    .checkin-data-box .users .user .avatar-box.pl::after {
        content: '事假';
        background-color: #4A7FB5;
    }

    .checkin-data-box .users .user .avatar-box.el::after {
        content: '早退';
        background-color: #C56073;
    }

    .checkin-data-box .users .user .avatar-box img {
        width: 72px;
        height: 72px;
    }

    .checkin-data-box .users .user .name {
        font-size: 24px;
        line-height: 100%;
        padding: 10px 20px 0 20px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        color: #ffffff;
    }

    .checkin-data-box .users .user .dis {
        margin-top: 15px;
        font-size: 24px;
        color: #BBC2C6;
        text-align: center;
    }

    .checkin-data-box .users .user .dis .dis-icon {
        display: inline-block;
        width: 24px;
        height: 24px;
        vertical-align: middle;
    }

    .checkin-data-box .users .user .dis .dis-label {
        display: inline-block;
        padding-left: 5px;
        vertical-align: middle;
    }
</style>


